import React from "react";
import moment from "moment";
import { FormRangeStartDatePicker } from "components/DatePicker/RangeDatePicker";

interface Props {
  value: moment.Moment;
  onChange: (value: moment.Moment, fromCalendar: boolean) => void;
  dueInDays: number;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
  inPageEdit?: {
    cancel: () => void;
    submit: () => void;
  }
}

export const DocumentSendDatePicker = (props: Props) => {
  const { value, onChange, dueInDays, minDate, maxDate, inPageEdit } = props;
  return (
    <FormRangeStartDatePicker
      validatorKey="sendDate"
      minDate={minDate ?? moment.utc().year(serverReference.constants.invoice.minSendYear).startOf("year")}
      maxDate={maxDate ?? moment.utc().year(serverReference.constants.invoice.maxSendYear).startOf("year")}
      value={value}
      onChange={onChange}
      rangeEnd={moment.utc(value).add(dueInDays, "days")}

      focusOnMount={inPageEdit != null}
      onEsc={inPageEdit?.cancel}
      onEnter={inPageEdit?.submit}
    />
  );
};

export default DocumentSendDatePicker;
